import Vue from "vue";
import mixin from "./mixin";
// import { VImg } from "vuetensils";
const firebase = require("./init-firebase");
import helpers from "./Foundation/helpers";
// LazyLoading Components
import LazyLoadDirective from "../components/master/Image/LazyLoader";
import Image from "@/components/master/Image/CustomImage.vue";

export default Plugin.install = () => {
	Vue.collection = path => {
		return firebase.firestore().collection(path);
	};
	Vue.mixin(mixin);
	Vue.directive("lazyload", LazyLoadDirective);
	Vue.component("lazy-image", Image);
	Vue.prototype.$helper = helpers;
	Vue.prototype.$firebase = firebase;
	Vue.prototype.$firestore = () => {
		return firebase.firestore();
	};
};
